// CORE
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ViewChildren,
  QueryList,
} from "@angular/core";
// import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ViewChildren, QueryList } from '@angular/core';

// SERVICE
import { AppService } from "../services/app.service";
import { HomepageService } from "../services/homepage.service";

// MODEL
import { Badge } from "../model/badge";
import { LessonInfo } from "../model/lessonInfo";
import { News } from "../model/news";
// import {NewsPreview} from '../model/news_preview';
import { Topbar } from "../model/topbar";

import * as Parallax from "parallax-js";
import * as $ from "jquery";
import { environment } from "../../environments/environment";
import { SwiperComponent } from "angular2-useful-swiper/lib/swiper.component";

import { THROW_IF_NOT_FOUND } from "@angular/core/src/di/injector";
import { routerNgProbeToken } from "@angular/router/src/router_module";
import { Router, RouterLink } from "@angular/router";

declare var Parallax: any;

@Component({
  selector: "app-homepage",
  templateUrl: "./homepage.component.html",
  styleUrls: ["./homepage.component.css"],
  providers: [HomepageService],
})
export class HomepageComponent implements OnInit, OnDestroy {
  @ViewChild("mySwiper") mySwiper: SwiperComponent;
  // Utilizzatti per l'effetto parallasse sui singoli OD sulla mappa
  @ViewChild("mainSection") mainSection: ElementRef;
  @ViewChildren("scene") scenes: QueryList<ElementRef>;

  header: Topbar;
  headerList: Topbar[];
  showHeaderList = false;
  showUserTools = false;
  loaded: string;
  username: string;
  currentDateTime: Date = new Date();

  headCourses: number[] = [];

  // Definisce le proprietà dello slider delle news
  config_news: Object;
  config_news_modal: Object;

  // id del corso corrente
  id_course: number;

  // contiene info riguardanti la lezione corrente
  lessonInfo: LessonInfo;
  showInfo = false;
  profileData: any[];
  profileHardData: Object;
  hardPoints: number;
  profileSoftData: Object;
  softPoints: number;
  profileBadges: {
    badges: Badge[];
  } = {
    badges: [],
  };
  noData: boolean;
  // allNews: News;
  // findNews: News;
  // singleNews: News;
  // newsPreview: NewsPreview;
  // newsNumber: Number;
  // readMore = false;
  // showNews = false;
  audio: any = new Audio();
  isOn: boolean;
  fakeUserId: number;
  language: any;
  key: string = localStorage.getItem("key");
  stateUser: string = localStorage.getItem("stateUser");

  // Swiper config
  config_courses = {
    navigation: {
      nextEl: ".swiper-navigation-container .swiper-button-next",
      prevEl: ".swiper-navigation-container .swiper-button-prev",
    },

    init: true,
    // Optional parameters
    speed: 1000,
    direction: "horizontal",
    parallax: true,
    loop: false,
    preventClicks: true,
    centeredSlides: true,
    slidesPerView: 1,
    // If we need pagination
    pagination: {
      el: ".swiper-pagination",
    },
    breakpoints: {
      // when window width is >= 600px - nel caso adeguare anche il css di .swiper-wrapper

      600: {
        centerInsufficientSlides: true,
        slidesPerView: 2,
        centeredSlides: false,
      },
      1400: {
        centerInsufficientSlides: true,
        slidesPerView: 3,
        centeredSlides: false,
      },
    },
  };

  relearnit_base_url = environment.relearnit_base_url;
  swiper_ready: boolean;

  showProceduraRicaricaModal : boolean = false;
  showWesnaiModal : boolean = false;
  showContiDiGiocoModal: boolean = false;
  showVirtualBallzModal: boolean = false;

  constructor(
    private homePageService: HomepageService,
    private appService: AppService,
    private router: Router
  ) {
    this.homePageService = homePageService;
    this.fakeUserId = JSON.parse(localStorage.getItem("fakeUser"));
    this.isOn = !!JSON.parse(localStorage.getItem("musicOn")) || false;

    setTimeout(() => {
      this.loaded = "loaded";
    }, 300);

    // this.audio.src = 'assets/audio/Blue tommaso casigliani.mp3';
    // this.audio.load();
    // this.manageAudio();
    // this.config_news = {
    //   direction: 'vertical',
    //   loop: false,
    //   grabCursor: true,
    //   mousewheelControl: true,
    //   mousewheelForceToAxis: true,
    //   mousewheelInvert: true,
    //   scrollbarHide: false,
    //   scrollbarDraggable: true,
    //   scrollbar: '.news-resume .swiper-scrollbar',
    // };
    // this.config_news_modal = {
    //   scrollbar: '.news-modal .swiper-scrollbar',
    //   loop: false,
    //   direction: 'vertical',
    //   slidesPerView: 'auto',
    //   slidesOffsetBefore: 21,
    //   slidesOffsetAfter: 13,
    //   mousewheelControl: true,
    //   scrollbarHide: false,
    //   scrollbarDraggable: true,
    //   freeMode: true
    // };
  }

  ngOnInit() {
    $(".wrap").click(() => {
      // $('#firstVideo').css('display', 'none');
      // $('#firstVideoiframe').attr('src', '');
      localStorage.setItem("stateUser", "Authentication Success");
    });
    localStorage.removeItem("headerList");
    if (localStorage.getItem("headerList")) {
      this.headerList = JSON.parse(localStorage.getItem("headerList"));
      this.header = JSON.parse(localStorage.getItem("header"));
      // this.getNewsPreview(this.header.course_id);
      this.getCurrentLessonId(this.header.course_id, this.header.user_id);
      this.getProfileData(this.header.user_id, this.header.course_id);
      setTimeout(() => {
        this.initSwiper();
      });
      this.username = JSON.parse(localStorage.getItem("header")).username;
    } else {
      this.getHeader(JSON.parse(localStorage.getItem("fakeUser")));
    }
    // this.swiper_ready = true;
  }

  ngAfterViewInit() {
    // Effetto parallasse sui singoli corsi sulla mappa
    let mainSection = <HTMLElement>this.mainSection.nativeElement;
    mainSection.classList.add("loaded");

    // Prima chiamata
    this.scenes.forEach((elem, index) => {
      this.addParallax(elem);
    });

    // Chiamata ad ogni cambiamento
    this.scenes.changes.subscribe(() => {
      this.scenes.forEach((elem, index) => {
        this.addParallax(elem);
      });
    });
  }

  // Effetto parallasse
  addParallax(elem) {
    new Parallax(elem.nativeElement, {
      relativeInput: true,
      hoverOnly: true,
    });
  }

  // All'interno solo codice per lo Swiper
  initSwiper(): void {
    var slidesSameClass = $(".swiper-slide");

    var slideWidth = slidesSameClass[0] ? slidesSameClass[0].offsetWidth : null;
    var slidesTotalNumber = slidesSameClass.length;
    var slidesTotalWidth = slidesTotalNumber * slideWidth;

    var i;

    var bgStars = $(".bg-stars");
    for (i = 0; i < bgStars.length; i++) {
      bgStars[i].style.width = slidesTotalWidth * 2 + "px";
    }
    var bgDust = $(".bg-dust");
    for (i = 0; i < bgDust.length; i++) {
      bgDust[i].style.width = slidesTotalWidth + "px";
    }

    var incrementalTranslationStars = 0;
    var incrementalTranslationDust = 0;

    window.addEventListener("resize", () => {
      slideWidth = slidesSameClass[0] ? slidesSameClass[0].offsetWidth : null;
      slidesTotalNumber = slidesSameClass.length;
      slidesTotalWidth = slidesTotalNumber * slideWidth;
      for (i = 0; i < bgStars.length; i++) {
        bgStars[i].style.width = slidesTotalWidth * 2 + "px";
      }
      for (i = 0; i < bgDust.length; i++) {
        bgDust[i].style.width = slidesTotalWidth + "px";
      }

      this.mySwiper.Swiper.init();
      this.username = JSON.parse(localStorage.getItem("header")).username;
    });

    // setTimeout(() => {
    //   this.mySwiper.Swiper.slideTo(1, 1300);
    //   this.mySwiper.Swiper.slideTo(2, 1300);
    //   this.mySwiper.Swiper.slideTo(3, 1300);
    // }, 200);

    let prevActiveIndexSlide = -1;
    this.mySwiper.Swiper.on("slideChange", function (swiper) {
      let isNext = swiper.activeIndex >= prevActiveIndexSlide;
      prevActiveIndexSlide = swiper.activeIndex;
      incrementalTranslationStars +=
        (isNext ? 1 : -1) * Math.floor(slideWidth / 3);
      incrementalTranslationDust += (isNext ? 1 : -1) * 100;
      for (i = 0; i < bgStars.length; i++) {
        bgStars[i].style.transform =
          "translateX(-" + incrementalTranslationStars + "px)";
        bgDust[i].style.transform =
          "translateX(-" + incrementalTranslationDust + "vw)";
      }
    });

    if (this.headerList.length == 1) {
      window.localStorage.setItem("header", JSON.stringify(this.headerList[0]));
      this.router.navigate(["/course"]);
    }
  }

  ngOnDestroy() {
    this.isOn = false;
    this.audio.pause();
  }

  // Funzione che apre il modale del corso
  openCourseInfo($event) {
    var swiperPrevBtn = $(".swiper-button-prev");
    var swiperNextBtn = $(".swiper-button-next");
    var infoParent = $event.target.parentNode.parentNode;
    infoParent.classList.toggle("show-info-modal");
    this.mySwiper.Swiper.allowSlideNext = false;
    this.mySwiper.Swiper.allowSlidePrev = false;
    swiperPrevBtn[0].classList.toggle("swiper-button-hidden");
    swiperNextBtn[0].classList.toggle("swiper-button-hidden");
  }

  // Funzione che chiude il modale del corso
  closeCourseInfo() {
    var parentSlide = $(".show-info-modal");
    console.log("🚀 ~ HomepageComponent ~ parentSlide", parentSlide);
    var swiperPrevBtn = $(".swiper-button-prev");
    var swiperNextBtn = $(".swiper-button-next");
    parentSlide[0].classList.toggle("show-info-modal");
    this.mySwiper.Swiper.allowSlideNext = true;
    this.mySwiper.Swiper.allowSlidePrev = true;
    swiperPrevBtn[0].classList.toggle("swiper-button-hidden");
    swiperNextBtn[0].classList.toggle("swiper-button-hidden");
  }

  getHeader(id: number, index?: number): void {
    this.appService.getHeader(this.fakeUserId, this.key).subscribe((result) => {
      console.log("header");
      
      console.log(result);

      // Conversione data d'inizio e data di fine in ms per confronto con orario attuale)
      result.forEach((header) => {
        header.course_date_end_ms = Date.parse(header.course_date_end);
        header.course_date_start_ms = Date.parse(header.course_date_start);
      });
      this.headerList = result;

      const idCourse = localStorage.getItem("idCourse");



      if (idCourse == null && !this.header) {
        this.header = result[0];
        this.header["courseIndex"] = 0;
      } else if (index != null) {
        this.header = result[index];
        this.header["courseIndex"] = index;
      } else if (idCourse != null) {
        this.header = this.headerList.find(
          (value) => value.course_id + "" === idCourse
        );
        this.header["courseIndex"] = this.headerList.indexOf(this.header);
      } else {
        this.header = result[0];
        this.header["courseIndex"] = 0;
      }
      localStorage.setItem("headerList", JSON.stringify(this.headerList));
      localStorage.setItem("header", JSON.stringify(this.header));
      localStorage.removeItem("idCourse");

      console.log(this.headerList.length);
      if (this.headerList.length == 1) {
        window.localStorage.setItem(
          "header",
          JSON.stringify(this.headerList[0])
        );
        this.router.navigate(["/course"]);
      }

      this.headerList.forEach((header) => {
        
        // If course is "Manuali" or "Video Tutorial" increment head courses
        const videoCourse = [14, 15, 16, 17, 19, 20, 22].find(id => id == header.course_id );
        const manualiCourse = [8, 9, 10, 11, 12, 13, 21].find(id => id == header.course_id);
        
        if(manualiCourse)
          this.headCourses.push(manualiCourse);
        else if(videoCourse)
          this.headCourses.push(videoCourse);

      })

      // this.getCurrentLessonId(this.header.course_id, this.header.user_id);
    });
  }

  getCurrentLessonId(id_lesson: number, user_id: number) {
    this.appService
      .getCurrentLessonId(id_lesson, user_id, this.key)
      .subscribe((result) => {
        this.lessonInfo = result;
        this.getProfileData(this.header.user_id, id_lesson);
      });
  }

  getProfileData(user_id: number, course_id: number): void {
    this.homePageService
      .getProfileData(user_id, course_id, this.key)
      .subscribe((result) => {
        this.noData = false;
        this.profileData = result;
        this.profileHardData = this.profileData[0];
        this.profileSoftData = this.profileData[1];
        this.profileBadges = this.profileData[2];
        // this.getNewsPreview(course_id);
      });
    // this.getNewsPreview(course_id);
  }

  // getNewsPreview(course_id: number): void {
  //   this.homePageService.getNewsPreview(course_id, this.key)
  //     .subscribe(result => {
  //       this.newsPreview = result;
  //       let i;
  //       for (i in this.newsPreview) {
  //         if (this.newsPreview[i].link == 'none') {
  //           this.newsPreview[i].link = '';
  //         }
  //       }
  //       this.newsNumber = result['length'];
  //     });

  //   setTimeout(() => {
  //     window.dispatchEvent(new Event('resize'));
  //   }, 500);
  // }

  // getAllNews(course_id: number): void {
  //   this.homePageService.getAllNews(course_id, this.key)
  //     .subscribe(result => {
  //       this.allNews = result;
  //     });
  //   setTimeout(() => {
  //     window.dispatchEvent(new Event('resize'));
  //   }, 500);
  // }

  // searchNews(letter: string, course_id: number): void {
  //   this.readMore = false;
  //   if (letter == '') {
  //     this.getAllNews(course_id);
  //   } else {
  //     this.homePageService.searchNews(letter, course_id, this.key)
  //       .subscribe(result => {
  //         this.findNews = result;
  //       });
  //   }
  // }

  // getSingleNews(course_id: number, news_id: number): void {
  //   this.readMore = true;
  //   this.showNews = true;
  //   this.homePageService.getSingleNews(course_id, news_id, this.key)
  //     .subscribe(result => {
  //       this.singleNews = result[0];
  //     });
  //   setTimeout(() => {
  //     window.dispatchEvent(new Event('resize'));
  //   }, 500);
  // }

  // reproduceAudio(): void {
  //   localStorage.setItem('musicOn', JSON.stringify(true));
  //   this.audio.loop = true;
  //   this.audio.play();
  // }

  // stopAudio(): void {
  //   localStorage.setItem('musicOn', JSON.stringify(false));
  //   this.audio.pause();
  // }

  // manageAudio(): void {
  //   this.isOn = !this.isOn;
  //   if (this.isOn) {
  //     this.stopAudio();
  //   } else {
  //     this.reproduceAudio();
  //   }
  // }

  isInHeadCourse(id: number): boolean{
    return this.headCourses.find(courseId => courseId == id) ? true : false
  }

  checkMenuOpen(): boolean {
    if (this.showUserTools) {
      this.showUserTools = false;
    }
    return this.showUserTools;
  }

  checkHeaderListOpen(): boolean {
    if (this.showHeaderList) {
      this.showHeaderList = false;
    }
    return this.showHeaderList;
  }

  goOnCourse(indexCourse: number) {
    // Check corso ancora non scaduto temporalmente
    if (
      new Date(this.headerList[indexCourse].course_date_start_ms) >
        this.currentDateTime ||
      new Date(this.headerList[indexCourse].course_date_end_ms) <
        this.currentDateTime
    )
      return;
    window.localStorage.setItem(
      "header",
      JSON.stringify(this.headerList[indexCourse])
    );
    this.router.navigate(["/course"]);
  }

  goToVideoTutorial() {
    const courseIndex = this.headerList.findIndex(hl => {
      return [14, 15, 16, 17, 19, 20, 22].includes(Number(hl.course_id));
    });

    if(courseIndex !== -1)
      this.goOnCourse(courseIndex)
  }

  goToProblematicPlayerCourse() {
    const courseIndex = this.headerList.findIndex(hl => {
      return [75, 76, 77, 78, 79, 80, 81].includes(Number(hl.course_id));
    });

    if(courseIndex !== -1)
      this.goOnCourse(courseIndex)
  }

  goToVademecumCourse() {
    const courseIndex = this.headerList.findIndex(hl => {
      return [82, 83, 84, 85, 86, 87, 88].includes(Number(hl.course_id));
    });

    if(courseIndex !== -1)
      this.goOnCourse(courseIndex)
  }

  goToPureFunCourse() {
    const courseIndex = this.headerList.findIndex(hl => {
      return [89,90,91].includes(Number(hl.course_id));
    });

    if(courseIndex !== -1)
      this.goOnCourse(courseIndex)
  }

  logout(): void {
    localStorage.clear();
  }

  sanitizeCourseTitle(courseName: string){
    let title = courseName;
    title = title.replace('Amministratore - ', '');
    title = title.replace('amministratore - ', '');
    title = title.replace('Dipendenti - ', '');
    title = title.replace('dipendenti - ', '');
    title = title.replace('Negozio - ', '');
    title = title.replace('negozio - ', '');
    title = title.replace('PGS - ', '');
    title = title.replace('pgs - ', '');
    title = title.replace('VLT - ', '');
    title = title.replace('vlt - ', '');
    title = title.replace('Noleggiatore - ', '');
    title = title.replace('noleggiatore - ', '');
    title = title.replace('Snaipay PVR - ', '');
    title = title.replace('SnaipayPVR - ', '');
    title = title.replace('snaipayPVR - ', '');
    title = title.replace('Dipendenti Snaitech - ', '');
    title = title.replace('dipendenti snaitech - ', '');
    title = title.replace('HR Amministratore - ', '');
    title = title.replace('hr amministratore - ', '');

    return title;
  }
}



// WEBPACK FOOTER //
// ./src/app/homepage/homepage.component.ts